module.exports = ".user-avatar{width:35px;height:35px;border-radius:50%}\n"